import _ from "lodash";

const initialState = {
  sessionId: "",
  sidebarVisibility: false,
  isLoading: false,
  isReady: true,
  storeId: "",
  storeLogo: "",
  username: "",
  password: "",
  passwordChanged: false,
  storeColour: "",
  loginError: false,
  errorMessage: "",
  authenticated: false,
  pageRefresh: true,
  deviceId: "",
  deviceToken: "",
  resetPassword: 0, //0, 1 (sent), 2 (error), 3 (busy)
  isLoggedIn: false,
  isLoggedOut: false,
  isConnected: true,
  refresh: "",
  api: "https://www.in-formed.co.uk/api.php",
  apiv2: "https://www.in-formed.co.uk/api/v2",
  actionQueue: [],
  imageQueue: [],
  application_version: "3.0.28",
  terminal_os: "Web"
};

const informedWebApp = (state = initialState, action) => {
  switch (action.type) {
    case "SET_SIDEBAR_VISIBILITY":
      return Object.assign({}, state, {
        sidebarVisibility: action.visibility
      });
    case "SET_USERNAME":
      return Object.assign({}, state, {
        username: action.value
      });
    case "SET_RESETPASSWORD":
      return Object.assign({}, state, {
        resetPassword: action.value
      });
    case "SET_DEVICE_TOKEN":
      return Object.assign({}, state, {
        deviceToken: action.value
      });
    case "PAGE_REFRESH":
      return Object.assign({}, state, {
        pageRefresh: action.value
      });
    case "RESET_COPY":
      return {
        ...state,
        actionQueue: state.actionQueue.filter(c => c.draftName !== "")
      };
    case "RECEIVE_DRAFT_DATA":
      let elementQ = _.filter(state.actionQueue, {
        result_id: action.result_id,
        test: state.api === "https://www.in-formed.co.uk/api.php" ? false : true
      });
      let replacedItemIndexQ = _.findIndex(state.actionQueue, function(qItem) {
        return (
          qItem.result_id == action.result_id &&
          qItem.test ==
            (state.api === "https://www.in-formed.co.uk/api.php" ? false : true)
        );
      });
      if (elementQ.length === 1) {
        return Object.assign({}, state, {
          actionQueue: [
            ...state.actionQueue.slice(0, replacedItemIndexQ),
            {
              draftName: action.draft_name,
              test:
                state.api === "https://www.in-formed.co.uk/api.php"
                  ? false
                  : true,
              result_id: action.result_id,
              draft: action.draftData.data,
              saved: true,
              form_id: action.form_id,
              isDraft: true,
              storeId: action.storeId,
              uuid: elementQ[0].uuid,
              icon_path: elementQ[0].icon_path,
              form_version: action.form_version,
              date_added: action.date_added,
              notification_id: elementQ[0].notification_id
            },
            ...state.actionQueue.slice(replacedItemIndexQ + 1)
          ]
        });
      } else {
        return Object.assign({}, state, {
          actionQueue: [
            ...state.actionQueue,
            {
              draftName: action.draft_name,
              test:
                state.api === "https://www.in-formed.co.uk/api.php"
                  ? false
                  : true,
              result_id: action.result_id,
              draft: action.draftData.data,
              saved: true,
              form_id: action.form_id,
              isDraft: true,
              storeId: action.storeId,
              uuid: action.uuid,
              icon_path: action.icon_path,
              form_version: action.form_version,
              date_added: action.date_added
            }
          ]
        });
      }
    case "DELETE_DRAFT":
      return {
        ...state,
        actionQueue: state.actionQueue.filter(c => c.uuid !== action.uuid),
        imageQueue: state.imageQueue.filter(c => c.uuid !== action.uuid)
      };
    case "DELETE_ALL_DRAFTS":
      return {
        ...state,
        actionQueue: state.actionQueue.filter(c => c.isDraft === false),
        imageQueue: state.imageQueue.filter(c => c.isDraft === false)
      };
    case "SET_PASSWORD":
      return Object.assign({}, state, {
        password: action.value,
        passwordChanged: action.changed
      });
    case "RESET_PASSWORD_CHANGED":
      return Object.assign({}, state, {
        passwordChanged: false
      });
    case "SET_DRAFT_SAVED":
      const updatedDraftItem = state.actionQueue.map(item => {
        if (item.uuid === action.uuid) {
          return {
            ...item,
            saved: true,
            result_id: action.result_id,
            date_added: action.date_added,
            date_modified: action.date_modified
          };
        }

        return item;
      });
      return { ...state, actionQueue: updatedDraftItem };

    case "LOGIN":
      return { ...state, isLoggedIn: true, isLoggedOut: false };
    case "SET_API":
      return { ...state, api: action.value.api, apiv2: action.value.apiv2 };
    case "ADD_TO_QUEUE":
      let eState = {
        ...state,
        actionQueue: state.actionQueue.filter(c => c.uuid !== action.uuid)
      };

      return {
        ...eState,
        actionQueue: [
          ...eState.actionQueue,
          {
            draftName: action.draftName,
            test:
              state.api === "https://www.in-formed.co.uk/api.php"
                ? false
                : true,
            result_id: action.result_id,
            draft: action.draft,
            saved: action.saved,
            form_id: action.formId,
            isDraft: action.isDraft,
            storeId: action.storeId,
            uuid: action.uuid,
            form_title: action.title,
            form_version: action.version,
            icon_path: action.icon_path,
            latitude: action.latitude,
            longitude: action.longitude,
            notification_id: action.notification_id
          }
        ]
      };
    case "ADD_TO_IMAGE_QUEUE":
      let iq = _.filter(state.imageQueue, function(draft) {
        return !(
          Number(draft.element_id) === Number(action.element_id) &&
          draft.uuid === action.uuid &&
          draft.repeatingFormId === action.repeatingFormId &&
          draft.repeatingFormUUID === action.repeatingFormUUID &&
          draft.repeatingFormEdit === action.repeatingFormEdit &&
          draft.draftEdit === action.draftEdit
        );
      });

      return {
        ...state,
        imageQueue: [
          ...iq,
          {
            draftEdit: action.draftEdit,
            repeatingFormEdit: action.repeatingFormEdit,
            test:
              state.api === "https://www.in-formed.co.uk/api.php"
                ? false
                : true,
            repeatingFormId: action.repeatingFormId,
            repeatingFormUUID: action.repeatingFormUUID,
            repeatingFormIndex: action.repeatingFormIndex,
            uuid: action.uuid,
            element_id: action.element_id,
            storeId: action.storeId,
            filename: action.filename,
            fileType: action.fileType,
            error: action.error
          }
        ]
      };

    case "CLONE_IMAGES":
      let iqc = [];

      iqc = state.imageQueue.map(function(draft) {
        if (draft.uuid === action.uuid && !draft.draftEdit) {
          return { ...draft };
        }
      });

      iqc = _.filter(iqc, function(element) {
        return element !== undefined;
      });

      iqc.forEach(element => {
        element.draftEdit = true;
      });

      return {
        ...state,
        imageQueue: state.imageQueue.concat(iqc)
      };
    case "CLEAN_IMAGES":
      let iqD = [];

      iqD = _.filter(state.imageQueue, function(draft) {
        return !(draft.uuid === action.uuid && !draft.draftEdit);
      });

      iqD.forEach(element => {
        element.draftEdit = false;
      });

      return {
        ...state,
        imageQueue: iqD
      };

    case "RESET_IMAGES":
      let iqx = [];
      if (action.drafts) {
        iqx = _.filter(state.imageQueue, function(draft) {
          return !(draft.uuid === action.uuid && draft.draftEdit);
        });
      } else {
        if (!action.isDraft) {
          iqx = _.filter(state.imageQueue, function(draft) {
            return draft.uuid !== action.uuid;
          });
        } else {
          iqx = state.imageQueue;
        }
      }

      return {
        ...state,
        imageQueue: iqx
      };

    case "UPDATE_IMAGE_FORM_ELEMENT":
      const updatedItems = state.actionQueue.map(item => {
        if (item.uuid === action.uuid) {
          let element = _.filter(item.draft, function(draft) {
            return (
              Number(draft.element_id) === Number(action.element_id) &&
              draft.repeatingFormId ===
                (action.repeatingFormId !== -1
                  ? action.repeatingFormId
                  : undefined) &&
              draft.repeatingFormUUID ===
                (action.repeatingFormUUID !== -1
                  ? action.repeatingFormUUID
                  : undefined) &&
              draft.repeatingFormEdit ===
                (draft.repeatingFormEdit === undefined
                  ? undefined
                  : action.repeatingFormEdit)
            );
          });
          let replacedItemIndex = _.findIndex(item.draft, function(draft) {
            return (
              Number(draft.element_id) === Number(action.element_id) &&
              draft.repeatingForm ===
                (action.repeatingForm ? action.repeatingForm : undefined) &&
              draft.repeatingFormUUID ===
                (action.repeatingFormUUID !== -1
                  ? action.repeatingFormUUID
                  : undefined) &&
              draft.repeatingFormEdit ===
                (draft.repeatingFormEdit === undefined
                  ? undefined
                  : action.repeatingFormEdit)
            );
          });

          if (element.length === 1) {
            if (action.repeatingFormId !== -1) {
              return {
                ...item,
                draft: [
                  ...item.draft.slice(0, replacedItemIndex),
                  {
                    element_id: action.element_id,
                    element_value: action.element_value,
                    base64: action.base64,
                    repeatingFormId: action.repeatingFormId,
                    repeatingFormUUID: action.repeatingFormUUID,
                    repeatingFormIndex: action.repeatingFormIndex,
                    repeatingFormEdit: action.repeatingFormEdit
                  },
                  ...item.draft.slice(replacedItemIndex + 1)
                ]
              };
            } else {
              return {
                ...item,
                draft: [
                  ...item.draft.slice(0, replacedItemIndex),
                  {
                    element_id: action.element_id,
                    element_value: action.element_value,
                    base64: action.base64
                  },
                  ...item.draft.slice(replacedItemIndex + 1)
                ]
              };
            }
          } else {
            if (action.repeatingFormId !== -1) {
              return {
                ...item,
                draft: [
                  ...item.draft,
                  {
                    element_id: action.element_id,
                    element_value: action.element_value,
                    base64: action.base64,
                    repeatingFormId: action.repeatingFormId,
                    repeatingFormUUID: action.repeatingFormUUID,
                    repeatingFormIndex: action.repeatingFormIndex,
                    repeatingFormEdit: action.repeatingFormEdit
                  }
                ]
              };
            } else {
              return {
                ...item,
                draft: [
                  ...item.draft,
                  {
                    element_id: action.element_id,
                    element_value: action.element_value,
                    base64: action.base64
                  }
                ]
              };
            }
          }
        }
        return item;
      });
      return { ...state, actionQueue: updatedItems };

    case "REMOVE_FROM_IMAGE_QUEUE":
      let elements = _.filter(state.imageQueue, function(imageQueue) {
        return !(
          Number(imageQueue.element_id) === Number(action.element_id) &&
          imageQueue.repeatingFormUUID === action.repeatingFormUUID &&
          imageQueue.uuid === action.uuid
        );
      });

      return { ...state, imageQueue: elements };

    case "REMOVE_FROM_ACTION_QUEUE":
      return {
        ...state,
        imageQueue: state.imageQueue.filter(c => c.uuid !== action.uuid),
        actionQueue: state.actionQueue.filter(c => c.uuid !== action.uuid)
      };
    case "CHANGE_CONNECTION_STATUS":
      return Object.assign({}, state, {
        isConnected: action.isConnected
      });
    case "SET_STORE":
      return Object.assign({}, state, {
        storeId: action.store_id
      });
    case "SET_DEVICE":
      return Object.assign({}, state, {
        deviceId: action.deviceId
      });
    case "SET_LOGO":
      return Object.assign({}, state, {
        storeLogo: action.store_logo,
        storeColour: action.store_color
      });
    case "SET_LOADING":
      return Object.assign({}, state, {
        isLoading: action.value
      });
    case "SET_READY":
      return Object.assign({}, state, {
        isReady: action.value
      });
    case "SET_AUTH_SESSION":
      return Object.assign({}, state, {
        sessionId: action.sessionid
      });
    case "LOGOUT":
      return {
        ...state,
        username: "",
        password: "",
        isLoggedOut: true,
        isLoggedIn: false,
        isLoading: false,
        loginError: false,
        authenticated: false
      };
    case "CONNECT_FAIL":
      return {
        ...state,
        username: "",
        password: "",
        isLoggedOut: false,
        isLoggedIn: false,
        isLoading: false,
        loginError: false,
        authenticated: false
      };
    case "SET_AUTH":
      return Object.assign({}, state, {
        authenticated: action.authenticated,
        loginError: action.authenticated ? false : true,
        errorMessage: action.errorMessage
      });
    default:
      return state;
  }
};

export default informedWebApp;



// WEBPACK FOOTER //
// ./src/reducers/informedWebApp.js